import styleModule from './page.loader.module.css';
import { AppImages } from 'components';
import * as AppPics from 'assets/images';
import { memo, useEffect } from 'react';

function PageLoader() {
  useEffect(() => {
    document.body.style.backgroundColor = '#ffe6e6';
    return () => {
      document.body.style.backgroundColor = 'transparent';
    };
  }, []);

  return (
    <div className={styleModule.wrap}>
      <div className={styleModule.loading}>
        <div className={styleModule.bounceball}></div>
        <div className={styleModule.text}>
          <strong>LOADING...</strong>
        </div>
        <div className="logoWrap">
          <span className="logoWrap__logo">
            <AppImages alt="Edpodia Logo" src={AppPics.EdpodiaLogoSvg} />
          </span>
        </div>
      </div>
    </div>
  );
}

export default memo(PageLoader);
